const sides = { front:'Front', back:'Back', frontSilver:'FrontSilver', backSilver:'BackSilver' };
export const captureInputKey = target => JSON.stringify([target.side,target.elementId]);
export const captureSide = surface => sides[surface];

export function prospectiveCaptureInputs(state) {
  if (!state.newCaptureInputDraft || state.cardId) return { options:[], invalid:false };
  const surfaces = { ...state.surfaces, [state.activeSurface]:state.objects };
  const options=[];const seen=new Set();let invalid=false;
  for (const target of state.createdCaptureInputs || []) {
    const key=captureInputKey(target);if(seen.has(key))continue;seen.add(key);
    const surface=Object.keys(sides).find(s=>sides[s]===target.side);
    const matches=(surfaces[surface] || []).filter(o=>o.id===target.elementId);
    if(matches.length>1){invalid=true;continue;}
    if(matches.length===1&&matches[0].type==='photo') options.push({...target,key});
  }
  return {options,invalid};
}

export function prospectiveCaptureBinding(state) {
  if (!state.newCaptureInputDraft || state.cardId) return undefined;
  const {options,invalid}=prospectiveCaptureInputs(state);
  if(!invalid&&!options.length)return undefined;
  const selected=state.captureInputSelection == null && options.length===1
    ? options[0] : options.find(o=>o.key===state.captureInputSelection);
  if(invalid||!selected){const error=new Error('Choose the captured photo input before saving this new template.');error.code='CAPTURE_FRAME_REQUIRED';throw error;}
  const target={side:selected.side,elementId:selected.elementId};
  return {version:'everyid.photo-binding/1',source:'media.photo',frames:[target],referenceFrame:{...target}};
}

export function reconcileCaptureBinding(state, surfaces) {
  const prospective = prospectiveCaptureBinding(state);
  if (prospective || !state.capturePhotoBinding) return prospective;
  const photos = (surfaces.front || []).filter(object => object?.type === 'photo');
  const valid = photos.filter(photo => typeof photo.id === 'string' && photo.id.trim());
  if (!valid.length) return undefined;
  const declaration = state.capturePhotoBinding;
  const reference = declaration.referenceFrame || (declaration.frames?.length === 1 ? declaration.frames[0] : null);
  if (reference?.side === 'Front' && valid.some(photo => photo.id === reference.elementId) &&
      declaration.frames?.some(frame => frame.side === 'Front' && frame.elementId === reference.elementId)) {
    return declaration;
  }
  // A deleted primary follows the first valid front photo in drawing order. The
  // remaining photo objects use the same captured source and need no extra binding.
  const target = {side:'Front', elementId:valid[0].id};
  return {version:'everyid.photo-binding/1',source:'media.photo',frames:[target],referenceFrame:{...target}};
}
